
interface LabeledBtnProps {
    icon: JSX.Element;
    label: string;
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
}

export const LabeledBtn: React.FC<LabeledBtnProps> = ({ icon, label, onClick, className }) => {
    return (
        <div className={`flex flex-col items-center mr-2 `}>
            <button
                className={`btn mb-1 ${className}`}
                onClick={onClick}
                aria-label={`Select ${label}`}>
                {icon}
            </button>
            <span>{label}</span>
        </div>
    )
}